import { rem } from 'polished'
import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`text-center`}
`

export const Main = styled.div`
  ${tw`grid sm:grid-cols-2 md:grid-cols-4`}
  border-top: 1px solid var(--color-grey);
  border-left: 1px solid var(--color-grey);
`

export const Section = styled.a`
  ${tw`flex flex-grow justify-center items-center relative w-full`};

  text-transform: uppercase;
  line-height: 1.25rem;
  letter-spacing: 0.15em;
  font-size: ${rem(13)};
  color: var(--color-gold);

  min-height: ${rem(45)};
  height: ${rem(68)};
  border-right: 1px solid var(--color-grey);
  border-bottom: 1px solid var(--color-grey);

  &::before,
  &::after {
    content: '█';
    ${tw`block absolute`};
    left: -1px;
    right: -1px;
    background-color: white;
    font-family: sans-serif;
    line-height: normal;
    font-size: 8px;
    color: ${({ $selected }) => ($selected ? 'var(--color-grey)' : 'var(--color-white)')};
  }

  &:hover::before,
  &:hover::after {
    color: var(--color-grey);
  }

  &::before {
    ${tw`top-0 pb-1`};
  }

  &::after {
    ${tw`bottom-0 pt-2`};
  }
`
